import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { IonApp, IonPage, IonContent, IonText } from "@ionic/react";

const PortalPage = lazy(() =>
  import("@/pages/PortalPage").then((m) => ({ default: m.PortalPage })),
);

// No localStorage persistence: sessions live ~1h and the cache holds session
// tickets, connections, and health data — persisting that leaves PII at rest on
// (often shared) devices long after the session dies. A reload just refetches.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App() {
  return (
    <IonApp>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Suspense fallback={null}>
            <Routes>
              {/* Embed routes (iframe/WebView mode — session from hash fragment) */}
              <Route path="/embed" element={<PortalPage embed />} />
              <Route path="/embed/portal" element={<PortalPage embed />} />
              <Route path="/:sessionId/embed" element={<PortalPage embed />} />

              {/* Session ID routes */}
              <Route path="/:sessionId/portal" element={<PortalPage />} />
              <Route path="/:sessionId" element={<PortalPage />} />

              {/* Fallback route */}
              <Route
                path="/"
                element={
                  <IonPage>
                    <IonContent className="ion-padding ion-text-center">
                      <IonText>
                        <h1>Movesome</h1>
                      </IonText>
                      <IonText color="medium">
                        <p>Please access this page with a valid session URL.</p>
                      </IonText>
                    </IonContent>
                  </IonPage>
                }
              />
            </Routes>
          </Suspense>
        </Router>
      </QueryClientProvider>
    </IonApp>
  );
}

export default App;
